//Redux
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { closeModal } from "../../reducers/modalReducer";
//Components
import { Modal } from "@almafintech/react-components/Modal";
//Styles
import styles from "./AccountObjectiveModal.module.scss";
//Utils
import { accountObjectiveModal } from "../../i18n/securities/accountObjectiveModal";

const AccountObjectiveModal = ({ language }: { language: "es" | "en" }) => {
	const { container, item } = styles;

	const dispatch = useAppDispatch();

	const { modalName } = useAppSelector((state) => state.modal);

	const handleClose = () => {
		dispatch(closeModal());
	};

	return (
		<Modal
			isOpen={modalName === "account-objective"}
			onClose={handleClose}
			className={container}
			header={
				<header>
					<h1>{accountObjectiveModal[language].header}</h1>
				</header>
			}
		>
			<section>
				<div className={item}>
					<p>{accountObjectiveModal[language].incomeTitle}</p>
					<p>{accountObjectiveModal[language].income}</p>
				</div>
				<div className={item}>
					<p>{accountObjectiveModal[language].longTermGrowthTitle}</p>
					<p>{accountObjectiveModal[language].longTermGrowth}</p>
				</div>
				<div className={item}>
					<p>{accountObjectiveModal[language].shortTermGrowthTitle}</p>
					<p>{accountObjectiveModal[language].shortTermGrowth}</p>
				</div>
			</section>
		</Modal>
	);
};

export default AccountObjectiveModal;
